import CommentInput from "./commentInput.component";

export default CommentInput;
